import { render, staticRenderFns } from "./PropertiesList.vue?vue&type=template&id=814f2a68&scoped=true"
import script from "./PropertiesList.vue?vue&type=script&lang=js"
export * from "./PropertiesList.vue?vue&type=script&lang=js"
import style0 from "./PropertiesList.vue?vue&type=style&index=0&id=814f2a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f2a68",
  null
  
)

export default component.exports